import { api } from "./configs/axiosConfigs";

export const BannerAPI = {
  getBanners: async () => {
    const response = await api
      .get("/banner")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },

  getBannersSearch: async (term) => {
    const response = await api
      .get(`/banner?term=${term}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },

  createBanner: async (data: any) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", data.description || "");
    formData.append("order", String(data.order));
    formData.append("status", "1");
    formData.append("cta_text", data.cta_text || "");
    formData.append("cta_url", data.cta_url || "");
    formData.append("start_date", data.start_date || "");
    formData.append("end_date", data.end_date || "");
    formData.append("status", data.status);
    if (data.image instanceof File) {
      formData.append("image", data.image);
    }
    const response = await api.post("/banner", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response) => response.data).catch((error) => {
      console.error(error);
      return error.response.data;
    });
    return response;
  },

  editBanner: async (id: number, data: any) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", data.description || "");
    formData.append("order", String(data.order));
    formData.append("status", "1");
    if (data.image instanceof File) {
      formData.append("image", data.image);
    }
    formData.append("cta_text", data.cta_text || "");
    formData.append("cta_url", data.cta_url || "");
    formData.append("start_date", data.start_date || "");
    formData.append("end_date", data.end_date || "");
    formData.append("status", data.status);
    const response = await api.post(`/banner/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response) => response.data).catch((error) => {
      console.error(error);
      return error.response.data;
    });
    return response;
  },

  deleteBanner: async (id: number) => {
    const response = await api
      .delete(`/banner/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        return error.response.data;
      });
    return response;
  },
};